// Object shows how to child height changed in every age
// F.e. from 48 to 54 months child will grow for 1.55 inches
const growth = {
    changes: [
        { "ageMonthes": "48", "change": "1.55"},
        { "ageMonthes": "54", "change": "1.4" },
        { "ageMonthes": "66", "change": "1.15" },
        { "ageMonthes": "78", "change": "1.35" },
        { "ageMonthes": "90", "change": "1.05" },
        { "ageMonthes": "102", "change": "1.20" },
        { "ageMonthes": "114", "change": "1" },
        { "ageMonthes": "138", "change": "1.15" }
    ]
}

export default growth;


// WEBPACK FOOTER //
// ./src/data/growth.js